import React from 'react';

import RowBlocksSecElem from 'sections/common/RowBlocksSec';

const RowBlocksSec = ({ data }) => {
  return <RowBlocksSecElem data={data} location="customer-experience" />;
};

export default RowBlocksSec;
